import Env from "../base/env";
import Component from "gia/Component";
import { RevealScale } from "../fx/Common";

export default class FxModule extends Component {
  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    //? Fns
    setTimeout(() => {
      RevealScale(this.DOM.view);
    }, Env.timingDelayFx);
  }
}
